import {Subject, Subscription} from 'rxjs';

import {EventEmitter} from '@angular/core';
import {IModalDialogV3} from '../interfaces/i-modal-dialog-v3';
import {IModalParamsV3} from '../interfaces/i-modal-params-v3';
import {ModalDynamicV3Service} from '../services/modal-dynamic-v3-service.service';

export abstract class ModalDialogV3 implements IModalDialogV3 {
    public modalParams?: IModalParamsV3;
    public modelChanged: Subject<any> = new Subject<any>();
    public myComponentRef: any;

    public isEscapeKeyClickFnDisabled = false;

    public globalEscapeKeyEvent = new EventEmitter<KeyboardEvent>();

    public globalEscapeKeyEventSub?: Subscription;
    public modalDynamicV3Service: ModalDynamicV3Service;
    public isClosed: boolean;

    public escapeAnnounceModel: {
        action: string;
        buttonType?: string;
        buttonLabel?: string;
    } = {
        action: 'ESCAPE',
        buttonType: undefined,
        buttonLabel: 'ESCAPE',
    }


    constructor() {
        this.registerEscapeKeyListener();
    }

    // this method should be used instead of subscribe, use new way of subscribing compatibile with rxjs 6
    public subscribeObserver<T>(observer: Partial<{
        next: (value: T) => void;
        error: (error: any) => void;
        complete: () => void
    }>): Subscription {
        return this.modelChanged.asObservable().subscribe(observer);
    }

    public subscribe<T>(nextFn: (value: T) => void): Subscription {
        return this.modelChanged.asObservable().subscribe({
            next: nextFn,
            error: (err) => {
                console.error('An error occurred in modal dynamic subscribe method:', err);
            },
            complete: () => {
            } // Ignored
        });
    }

    public close(): void {
        this.modalDynamicV3Service?.close(this);
    }

    public announceModelChanged(val?: any): void {
        this.modelChanged.next(val);
    }

    onEscapeKeyEvent() {
        if (this.isEscapeKeyClickFnDisabled) {
            return;
        }
        this.announceModelChanged(this.escapeAnnounceModel);
        this.close();
    }

    protected registerEscapeKeyListener() {
        this.globalEscapeKeyEventSub = this.globalEscapeKeyEvent.subscribe((event: KeyboardEvent) => {
            this.onEscapeKeyEvent();
        });
    }

}

